import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Inactive Assessor List")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Association", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course", -1)
const _hoisted_16 = { class: "col-md-2 mt-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "text-info" }, [
          /*#__PURE__*/_createElementVNode("b", { class: "text-primary" }, "Note:"),
          /*#__PURE__*/_createTextVNode(" (Last Updated: 08-01-2022 05:55 pm) ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "" }, "List of Inactive Assessor")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex justify-content-end col",
    "data-kt-industry-table-toolbar": "base"
  })
], -1)
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-light" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!
  const _component_OrganizationModal = _resolveComponent("OrganizationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, {
      onSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formSubmit())),
      class: "form",
      "validation-schema": _ctx.AssociationSchema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _hoisted_10,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Tranche",
                        modelValue: _ctx.batch.tranche_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Tranche-1",
                            value: "1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tranche-1")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Tranche-2",
                            value: "2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tranche-2")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Tranche-3",
                            value: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tranche-3")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Tranche-4",
                            value: "4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tranche-4")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createTextVNode(),
                      _hoisted_13,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Association",
                        modelValue: _ctx.batch.entity_id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: info.id,
                              label: info.entity_name,
                              value: info.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(info.entity_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Course",
                        modelValue: _ctx.batch.course,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.course) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "BACCO-MS | Medical Scribing | 2 | 160 | 31519",
                            value: "1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("BACCO-MS | Medical Scribing | 2 | 160 | 31519")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.courseNotice())),
                        type: "button",
                        class: "btn btn-success mt-6 p-3",
                        style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                      }, [
                        _createTextVNode(" Search "),
                        _hoisted_17
                      ])
                    ])
                  ]),
                  (_ctx.showCourseNotice == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                    : _createCommentVNode("", true),
                  (_ctx.showCourseNotice == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode(_component_Datatable, {
                          "table-data": _ctx.tableData,
                          "table-header": _ctx.tableHeader,
                          "enable-items-per-page-dropdown": true
                        }, {
                          "cell-sl": _withCtx(({ row }) => [
                            _createTextVNode(_toDisplayString(row.id), 1)
                          ]),
                          "cell-assessor_name": _withCtx(({ row: industry }) => [
                            _createTextVNode(_toDisplayString(industry.assessor_name), 1)
                          ]),
                          "cell-gender": _withCtx(({ row: industry }) => [
                            _createTextVNode(_toDisplayString(industry.gender), 1)
                          ]),
                          "cell-phone": _withCtx(({ row: industry }) => [
                            _createTextVNode(_toDisplayString(industry.phone), 1)
                          ]),
                          "cell-email": _withCtx(({ row: industry }) => [
                            _createTextVNode(_toDisplayString(industry.email), 1)
                          ]),
                          "cell-area_expertise": _withCtx(({ row: industry }) => [
                            _createTextVNode(_toDisplayString(industry.area_expertise), 1)
                          ]),
                          "cell-status": _withCtx(({ row: industry }) => [
                            _createTextVNode(_toDisplayString(industry.status == 1 ? "Active" : "Inactive"), 1)
                          ]),
                          "cell-actions": _withCtx(({ row: industry }) => [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.Approve(industry.id)),
                              class: "btn btn-icon btn-bg-success btn-active-color-primary btn-sm"
                            }, _hoisted_25, 8, _hoisted_23)
                          ]),
                          _: 1
                        }, 8, ["table-data", "table-header"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode(_component_OrganizationModal)
  ], 64))
}